type FlowInputFlusher = () => void;

const flowInputFlushers = new Set<FlowInputFlusher>();

export function registerFlowInputFlusher(
  flusher: FlowInputFlusher
): () => void {
  flowInputFlushers.add(flusher);
  return () => flowInputFlushers.delete(flusher);
}

export function flushFlowInputs(): void {
  flowInputFlushers.forEach((flusher) => flusher());
}
